import { useEffect, useState } from 'react';

// Minutes left until a paused run auto-abandons. Derived from the server's
// absolute deadline each tick, so a slow render can't make it drift.
export function useResumeCountdown(deadline: string | null): {
  minutes: number;
  seconds: number;
  expired: boolean;
} {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!deadline) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [deadline]);

  if (!deadline) return { minutes: 0, seconds: 0, expired: false };

  const left = Math.max(0, new Date(deadline).getTime() - now);
  return {
    minutes: Math.floor(left / 60000),
    seconds: Math.floor((left % 60000) / 1000),
    expired: left === 0,
  };
}
